import { FolderListDto } from "@common/dto/list-folder";

export enum IndividualGender {
    female = 0,
    male = 1,
    unknown = 2,
}

export type IndividualCreateDto = {
    name: string;
    gender: IndividualGender;
    homeFolderId: FolderListDto['id'];
};